import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useNavigate } from 'react-router-dom'; // Assuming you are using React Router for navigation

import Page from './Page';

const GenericError: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleGoBack = () => {
    navigate(-1); // Navigates to the previous page
  };

  const handleGoHome = () => {
    navigate('/'); // Navigates to the home page
  };

  return (
    <Page>
      <Box
        sx={{
          position: 'absolute',
          top: '30%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 4,
          p: 4,
          borderRadius: '5px',
          width: '60%',
          margin: 'auto',
          minHeight: 'auto%',
          padding: '20px',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant='h1'
          sx={{
            margin: '20px 0',
          }}
        >
          Oops! Something went wrong.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: '20px',
            flexDirection: 'column',
            flexGrow: 1,
          }}
        >
          <Typography>
            We are sorry, but an unexpected error has occurred. Please try again later.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: '10px',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <Button variant='secondary' size='large' onClick={handleGoBack}>
              Go Back
            </Button>
            <Button variant='secondary' size='large' onClick={handleGoHome}>
              Home
            </Button>
          </Box>
        </Box>
      </Box>
    </Page>
  );
};

export default GenericError;
